import { Subscription } from "@/pages/dashboard.tsx";
import useDevice from "@hooks/use_device.ts";
import { router } from "@inertiajs/react";
import useInertiaModal from "@hooks/use_inertia_modal.ts";
import CompanyLogo from "@components/company_logo.tsx";
import { SectionHeader } from "@sprout/typography.tsx";
import { IconButton, IconButtonLink } from "@sprout/icon_button.tsx";
import PreviewIcon from "@sprout/icons/preview.tsx";
import EditIcon from "@sprout/icons/edit.tsx";
import AlertTags from "@components/alert_tags.tsx";
import "./card.scss";

interface Props {
  subscription: Subscription;
  onEditWhilePaused?: (editPath: string, companyName: string) => void;
  modal?: boolean;
}

export const JobAlertsCard = ({ subscription, onEditWhilePaused, modal }: Props) => {
  const device = useDevice();
  const { openModal, onError } = useInertiaModal();

  const subscriptionOnClick = () => {
    if (device.isMobile) {
      if (onEditWhilePaused) {
        onEditWhilePaused(subscription.editPath, subscription.boardName);
      } else if (modal) {
        openModal(subscription.editPath);
      } else {
        router.visit(subscription.editPath);
      }
    }
  };

  return (
    <div className="job-alerts-card" onClick={subscriptionOnClick}>
      <div className="job-alerts-card__header">
        <div className="job-alerts-card__header__upper">
          <CompanyLogo
            logoUrl={subscription.logoUrl}
            companyName={subscription.boardName}
            size="small"
          />
          <div
            className="job-alerts-card__header__buttons"
            onClick={(event) => event.stopPropagation()}
          >
            {onEditWhilePaused ? (
              <IconButton
                icon={EditIcon}
                label="Edit subscription"
                size="md"
                onClick={() => onEditWhilePaused(subscription.editPath, subscription.boardName)}
                data-provides="edit-subscription"
              />
            ) : (
              <IconButtonLink
                icon={EditIcon}
                href={subscription.editPath}
                modal={modal}
                onError={onError}
                data-provides="edit-subscription"
              />
            )}
            <IconButtonLink
              external
              href={subscription.path}
              icon={PreviewIcon}
              data-provides="preview-board"
            />
          </div>
        </div>
        <SectionHeader as="h3">{subscription.boardName}</SectionHeader>
      </div>
      <AlertTags values={subscription.filters || []} />
    </div>
  );
};
